module.exports = __webpack_public_path__ + "img/unarmed.a5a228bd.svg";